import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPropertyLeased,
  IsBorrowerTypePropertyCompany,
} from '../../rules';
import IsPropertyLandlord from '../../rules/IsPropertyLandlord';

class PropertyLandlordAgreedRuleset implements Ruleset {
  private index: number;

  public setIndex(index: number): PropertyLandlordAgreedRuleset {
    this.index = index;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (IsBorrowerTypePropertyCompany.evaluate(data)) {
      return RulesetResult.HIDDEN;
    }
    const isLeased = IsPropertyLeased.evaluate(data);
    const isLandlord = IsPropertyLandlord.setIndex(this.index).evaluate(data);

    return isLeased && isLandlord
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyLandlordAgreedRuleset();
